import { useMemo } from "react";
import { extendMoment } from "moment-range";
import Moment from "moment";
const moment = extendMoment(Moment);

export const useActivity = (activeEntity) => {
  const disabledStartDate = useMemo(
    () => (current) => {
      return (
        current &&
        activeEntity["end_time"] &&
        current > moment(activeEntity["end_time"]).endOf("day")
      );
    },
    [activeEntity]
  );

  const disabledEndDate = useMemo(
    () => (current) => {
      return (
        current &&
        activeEntity["start_time"] &&
        current < moment(activeEntity["start_time"]).startOf("day")
      );
    },
    [activeEntity]
  );

  const disabledStartHours = useMemo(
    () => () => {
      var hours = [];
      const hour = activeEntity["end_time"]
        ? moment(activeEntity["end_time"]).get("hour")
        : 24;
      for (var i = 23; i > hour; i--) {
        hours.push(i);
      }
      return hours;
    },
    [activeEntity]
  );

  const disabledStartMinutes = useMemo(
    (selectedHour) => () => {
      const endHour = moment(activeEntity["end_time"]).get("hour");
      const endMinutes = moment(activeEntity["end_time"]).get("minute");
      var minutes = [];
      if (selectedHour === endHour) {
        for (var i = 59; i > endMinutes; i--) {
          minutes.push(i);
        }
      }
      return minutes;
    },
    [activeEntity]
  );

  const disabledEndHours = useMemo(
    () => () => {
      var hours = [];
      for (var i = 0; i < moment(activeEntity["start_time"]).get("hour"); i++) {
        hours.push(i);
      }
      return hours;
    },
    [activeEntity]
  );

  const disabledEndMinutes = useMemo(
    (selectedHour) => () => {
      const startHour = moment(activeEntity["start_time"]).get("hour");
      const startMinutes = moment(activeEntity["start_time"]).get("minute");
      var minutes = [];
      if (selectedHour === startHour) {
        for (var i = 0; i < startMinutes; i++) {
          minutes.push(i);
        }
      }
      return minutes;
    },
    [activeEntity]
  );

  return {
    disabledStartDate,
    disabledEndDate,
    disabledStartHours,
    disabledStartMinutes,
    disabledEndHours,
    disabledEndMinutes,
  };
};
